import { TicketPriority } from '@twiliointernal/services-common/containers/TicketDetailsView/definitions/types';
import { TicketStatus } from '@twiliointernal/services-common/definitions/types';
import { AccountStatus } from '@twiliointernal/org/twilio/e2-commons/shared/definitions';

export const mockEmptyGetUserResponse = {
  statusCode: 200,
  status: 200,
  success: true,
  data: {
    account: {
      active: 1,
      currentAccountSid: '',
      dateCreated: '',
      dateUpdated: '',
      emailAddr: '',
      emailValidated: true,
      firstName: '',
      flags: [],
      friendlyName: '',
      isoCountryCode: '',
      lastName: '',
      preferredLanguage: '',
      sid: '',
      status: AccountStatus.active,
      upgraded: true,
      userType: 1,
      version: 1,
    },
    user: {
      sid: '',
      emailAddr: '',
      firstName: '',
      lastName: '',
      friendlyName: '',
      dateCreated: '',
      dateUpdated: '',
      active: 1,
      isoCountryCode: '',
      userType: 1,
      currentAccountSid: '',
      emailValidated: true,
      preferredLanguage: '',
    },
  },
};

export const mockHasPersonalizedSupportPlan = true;

export const mockPriority = 'p3_general_issue' as TicketPriority;

export const mockSampleEmail = 'sample@email.com';

export const mockTicketId = 202020;

export const mockTicketStatus = 'new' as TicketStatus;

export const mockUser = {
  emailAddr: 'john.doe@email.com',
  firstName: 'John',
  lastName: 'Doe',
};

export const mockTicketDetails = {
  comments: [
    {
      attachments: [],
      author: {
        alias: '',
        displayName: '[D] CustomerOne SVC-ENG',
        id: 517971541398,
        isAuthor: true,
        isEndUser: true,
        name: '[D] CustomerOne SVC-ENG',
      },
      body: 'Initial Comment',
      createdAt: '2023-09-06T21:08:53Z',
      htmlBody:
        '<div class="zd-comment" dir="auto"><p dir="auto">Initial Comment</p></div>',
      id: 27460218473429,
      public: true,
    },
  ],
  createdAt: '2023-08-29T21:13:53Z',
  emailCcIds: [511362800546],
  id: mockTicketId,
  priority: mockPriority,
  product: { name: 'API', value: 'product_api' },
  requesterId: 839642453748,
  status: mockTicketStatus,
  subject: 'Test Twilio E2E Ticket',
  tags: [
    '4_personalized',
    'country_set_by_ip',
    'country_us',
    'created-console',
    'flowset:agent_create',
    'language_fr',
    'last-response-customer',
    'option_4',
    'org_level_pers',
    'p3_general_issue',
    'paid_support',
    'product_api',
    'repeat-response-customer',
    'schedule_default',
    'support_level_5_pers',
    'svc-jite-ps-routing',
    'svc-jite-sla',
    'svc_support_console',
    'svc_ticket_metrics_country',
    'svc_ticket_metrics_language',
    'user_level_personalized',
  ],
  updatedAt: '2023-09-06T21:02:32Z',
  users: [
    {
      id: 511362800546,
      url: 'https://somecdn.com/api/v2/users/511362800546.json',
      name: 'user1',
      email: mockSampleEmail,
      created_at: '2020-02-28T21:17:42Z',
      updated_at: '2020-02-28T21:17:43Z',
      time_zone: 'Pacific Time (US & Canada)',
      iana_time_zone: 'America/Los_Angeles',
    },
    {
      id: 517971541398,
      url: 'https://somecdn.com/api/v2/users/517971541398.json',
      name: '[D] CustomerOne SVC-ENG',
      email: 'svc-engineering-devs+test_customerOne@twilio.com',
      created_at: '2022-03-07T16:54:52Z',
      updated_at: '2023-09-06T13:53:12Z',
    },
  ],
};

export const mockTicketDetailsWithoutCcs = {
  ...mockTicketDetails,
  emailCcIds: [],
};

export const mockUseGetTicketDetailsResults = {
  success: true,
  data: {
    ...mockTicketDetails,
  },
};
